import { createContext } from 'react';

import type { NFileProvider } from '@app/providers/FileProvider/FileProvider.types';

export const FileContext = createContext<NFileProvider.Context>({
  file: '',
  setFile: () => {},
  extension: '',
  setExtension: () => {},
});
